<app-contract-form
  [edit]="false"
  [create]="false"
  [delete]="true"
  [details]="false"
  [id]="id"
  [(value)]="value"
  [access]="access()"
></app-contract-form>
